import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsDataClassificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-classic-data-classifications',
	path: '/plugins/servlet/project-config/:projectKey/data-classifications',
	exact: true,
};
